import { twMerge } from 'tailwind-merge';

/* Labelled form field with optional helper text. */
export function Field({ label, hint, children, className = '' }) {
	return (
		<div className={twMerge('flex flex-col gap-[7px]', className)}>
			{label && <label className="text-[13px] font-semibold text-slate-600">{label}</label>}
			{children}
			{hint && <div className="text-[12px] text-slate-400 leading-snug">{hint}</div>}
		</div>
	);
}

/* Step heading: big title + subtitle. */
export function StepHead({ title, sub }) {
	return (
		<div className="mb-6 max-w-2xl">
			<h2 className="text-[25px] font-semibold text-slate-800 tracking-tight m-0">{title}</h2>
			{sub && <p className="mt-[7px] text-[14.5px] text-slate-500 leading-relaxed">{sub}</p>}
		</div>
	);
}

/* Soft rounded pill (neutral chip used for languages, facts, etc.). */
export function Pill({ children, className = '' }) {
	return (
		<span className={twMerge('inline-flex items-center gap-1.5 bg-slate-100 text-slate-600 text-[12.5px] font-medium px-3 py-1.5 rounded-full', className)}>
			{children}
		</span>
	);
}

/* Section heading used on the Landing / Channels pages. */
export function SectionTitle({ kicker, title, sub, right }) {
	return (
		<div className="flex items-start justify-between gap-4 flex-wrap mb-5">
			<div>
				{kicker && <div className="text-[12px] font-bold tracking-[0.08em] uppercase text-primary mb-1.5">{kicker}</div>}
				<h2 className="m-0 text-[22px] font-semibold text-slate-800 tracking-tight">{title}</h2>
				{sub && <p className="mt-1.5 text-sm text-slate-500 max-w-xl leading-relaxed">{sub}</p>}
			</div>
			{right}
		</div>
	);
}
